import { Injectable } from '@angular/core';


const TOKEN_KEY = 'AuthToken';


@Injectable()
export class TokenStorageService {

  constructor() { }

  signOut() {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.clear();
  }

  public saveToken(token) {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY,  token);
  }

  public getToken(): string {
    return sessionStorage.getItem(TOKEN_KEY);
  }

  
  public saveFilter(filter) {
    window.sessionStorage.removeItem('filterParms');
    window.sessionStorage.setItem('filterParms',  filter);
  }

  public getFilter(): string {
    if (!sessionStorage.getItem('filterParms')) {
      let p='[]';
      return p
    }
    return sessionStorage.getItem('filterParms');
  }

  public saveDashFilter(filter) {
    window.sessionStorage.removeItem('filterDashParms');
    window.sessionStorage.setItem('filterDashParms',  filter);
  }

  public getDashFilter(): string {
    if(!sessionStorage.getItem('filterDashParms')) {
      let p='[]';
      return p
    }
    return sessionStorage.getItem('filterDashParms');
  }

  public tableData;
  public saveTableData(data) {
    this.tableData = data;
  }

  public getTableData() {
    return this.tableData
  }

  public sessionStorage_transfer =function(tokenServObj,event) {
    if(!event) { 
      event = window.event;
     } 

    if(!event.newValue) 
    return;  
   
    if (event.key == 'getSessionStorage') {
      localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
      localStorage.removeItem('sessionStorage'); 
    } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
      var data = JSON.parse(event.newValue);
      for (var key in data) {
        sessionStorage.setItem(key, data[key]);
      }
    }
  };

}
